import hoistNonReactStatic from 'hoist-non-react-statics';
import React, { Component } from 'react';
import { Breakpoints } from '../../../grid/constants';
import getDisplayName from '../../../utils/getDisplayName';

function isMobileBreakpoint() {
    return window.innerWidth <= Breakpoints.small;
}

export function setGridBreakpoints() {
    return WrappedComponent => {
        class WithMobileBreakpoint extends Component {
            static displayName = `WithMobileBreakpoint(${getDisplayName(WrappedComponent)})`;
            static WrappedComponent = WrappedComponent;

            render() {
                return (
                    <WrappedComponent
                        isMobileBreakpoint={isMobileBreakpoint}
                        {...this.props}
                    />
                );
            }
        }

        return hoistNonReactStatic(WithMobileBreakpoint, WrappedComponent);
    };
}
